"use strict";

//TODO: Crear un submitCertificate & forceDownload dinamico para recibir distintos tipos de certificados

const submitCertificate = (form, type) => {
    let fullname = form.get('fullname');
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0');
    let yyyy = today.getFullYear();
    let date = dd + '/' + mm + '/' + yyyy;
    forceDownloadDopplerDemo(fullname, date, type);
}

const forceDownloadDopplerDemo = (name, date, type) => {
    const demoType = (type === 'inicial') ? 'Inicial' : 'Avanzado';

    var xhr = new XMLHttpRequest(),
        encodeName = encodeURI(name),
        encodeDate = encodeURI(date),
        type = encodeURI(demoType),
        domainUrl = (local_object.is_prod == '1') ? 'certificate-dopplerdemo.php' : 'certificate-dopplerdemoqa.php',
        url = 'https://textify.fromdoppler.com/' + domainUrl + '?name=' + encodeName + `&type=${type}&date=` + encodeDate,
        fileName = `certificacion-dopplerdemo-${demoType.toLocaleLowerCase()}.png`;


    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function () {
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        var tag = document.createElement('a');
        tag.href = imageUrl;
        tag.download = fileName;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
    }
    xhr.send();
    document.querySelector('.academy__certificate__modal').classList.remove('open');
}

const forceDownload = (name, date) => {
    const text = 'realizó el Entrenamiento Doppler Demo Nivel Inicial, incorporando conocimientos sobre Doppler y Estrategias de Email, Automation & Data Marketing el día .;'
    var xhr = new XMLHttpRequest(),
        encodeName = encodeURI(name),
        encodeDate = encodeURI(date),
        encodeText = encodeURI(text),
        domainUrl = (local_object.is_prod == '1') ? 'certificate-bootcamp.php' : 'certificate-bootcampqa.php',
        url = 'https://textify.fromdoppler.com/' + domainUrl + '?name=' + encodeName + `&course=${encodeText},&date=%20el%20d%C3%ADa` + encodeDate,
        fileName = 'certificacion-bootcamp.png';


    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function () {
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        var tag = document.createElement('a');
        tag.href = imageUrl;
        tag.download = fileName;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
    }
    xhr.send();
    document.querySelector('.modalCertificateContainer').classList.add('ac-none');
}


export {
    submitCertificate
};
